module.exports = __webpack_public_path__ + "img/6.7ed57e29.jpg";